import React, { useState } from 'react'
import cx from 'classnames'
import Truncate from 'components/shared/Truncate'
import TealToolTip from 'components/TealToolTip'
import Icon from 'components/shared/Icon'

const Checkbox = ({ label, onClick, checked }) => {
  const [clamped, setClamped] = useState(false)

  return (
    <TealToolTip title={clamped ? label : ''} placement='right'>
      <div
        className='flex items-center filter-link w-100 black focus-outline-0 mt2 pointer'
        onClick={onClick}
        data-testid='deal-compare-checkbox'
      >
        <Icon
          className={cx('filter-checkbox-icon mr4', { 'dark-sea-green-3': checked })}
          name={{
            'icon-checkbox-marked': checked,
            'icon-checkbox-blank-thin-outline': !checked
          }}
        />
        <Truncate
          trimWhitespace
          width={192}
          onTruncate={(isClamped) => setClamped(isClamped)}
        >
          {label}
        </Truncate>
      </div>
    </TealToolTip>
  )
}

export default Checkbox
